module.exports = __webpack_public_path__ + "img/keshi@2x.b9e75398.png";